<div class="p-4 text-center box-informative"
     [ngClass]="enablePositionFixed ? 'position-fixed' : null">
    <div class="mb-3">
        <h4 class="text-18 text-dark-3">
            {{ title}}
        </h4>
        <span class="text-32 box-informative-quantity" *ngFor="let item of resolvedStepItems">
            <span class="f-clash-bold">
                {{ item.value?.toLocaleString('pt-BR', {style: 'decimal', maximumFractionDigits: 2}) ?? 0 }}
            </span>
            <span class="ms-2 text-18 d-block">
                {{ item.legend }}
            </span>
        </span>
    </div>
    <h4 class="text-18 text-dark-3">
        Emissão total
    </h4>
    <span class="text-32 box-informative-quantity">
        <span class="f-clash-bold">
            {{ totalEmissions?.toLocaleString('pt-BR', {style: 'decimal', maximumFractionDigits: 2}) ?? 0 }}
        </span>
       <app-co2-legend></app-co2-legend>
    </span>
</div>
